import React from "react";

export const Label: React.FunctionComponent = ({ children }) => (
  <label className="text-center">
    {children}
  </label>
)